
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BaseObject } from '@/interfaces/Base';

@Component({
   components: {
      ObjectLayoutSidebar: () => import('./_ObjectLayoutSidebar.vue'),
   },
})
export default class View extends Vue {
   @Prop({ type: [Number, String], default: 0 }) title!: number | string;
   @Prop({ type: [Object], default: 0 }) model!: BaseObject;
   @Prop({ type: [Boolean], default: false }) fixed!: boolean;
   @Prop({ type: [Boolean], default: false }) copy_action!: boolean;
   @Prop({ type: [Boolean], default: true }) create_action!: boolean;
   @Prop({ type: [Boolean], default: false }) remove_action!: boolean;
}
